<template>
  <span class="product-category-path">
    <span
      v-for="(category, index) in categories"
      :key="index"
    >
      <slot name="item" :category="category">
        {{ category.name }}
      </slot>
      <icon
        v-if="isNotLastItem(index)"
        name="chevron-right"
      />
    </span>
  </span>
</template>

<script>
export default {
  name: 'product-category-path',
  props: {
    categories: {
      type: Array,
      required: true,
    },
  },
  computed: {
    lastIndex() {
      return this.categories.length - 1;
    },
  },
  methods: {
    isNotLastItem(index) {
      return index < this.lastIndex;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ProductCategoryPath.vue?579d094a